import { render, staticRenderFns } from "./PrototypeVersion.vue?vue&type=template&id=b554c7c0&"
import script from "./PrototypeVersion.vue?vue&type=script&lang=js&"
export * from "./PrototypeVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports